var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M22.6596 21.1273L18.9496 17.4473C20.3897 15.6517 21.0871 13.3726 20.8984 11.0786C20.7097 8.78461 19.6493 6.65009 17.9351 5.11395C16.221 3.57781 13.9834 2.75682 11.6825 2.81978C9.38165 2.88274 7.19233 3.82487 5.56475 5.45245C3.93717 7.08003 2.99504 9.26935 2.93208 11.5702C2.86912 13.8711 3.69012 16.1087 5.22626 17.8228C6.76239 19.537 8.89691 20.5974 11.1909 20.7861C13.4849 20.9748 15.764 20.2774 17.5596 18.8373L21.2396 22.5173C21.3326 22.611 21.4432 22.6854 21.565 22.7362C21.6869 22.787 21.8176 22.8131 21.9496 22.8131C22.0816 22.8131 22.2123 22.787 22.3342 22.7362C22.456 22.6854 22.5666 22.611 22.6596 22.5173C22.8399 22.3308 22.9406 22.0816 22.9406 21.8223C22.9406 21.563 22.8399 21.3138 22.6596 21.1273ZM11.9496 18.8373C10.5651 18.8373 9.21176 18.4268 8.06062 17.6576C6.90948 16.8884 6.01227 15.7952 5.48245 14.5161C4.95264 13.237 4.81402 11.8295 5.08411 10.4717C5.35421 9.11381 6.0209 7.86653 6.99986 6.88756C7.97883 5.90859 9.22611 5.24191 10.584 4.97181C11.9418 4.70171 13.3493 4.84034 14.6284 5.37015C15.9075 5.89996 17.0007 6.79717 17.7699 7.94832C18.5391 9.09946 18.9496 10.4528 18.9496 11.8373C18.9496 13.6938 18.2121 15.4743 16.8994 16.7871C15.5866 18.0998 13.8061 18.8373 11.9496 18.8373Z",
    fill: "#848484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.795483ff423ab13cac4f5641f13a64f3.svg";
export { ForwardRef as ReactComponent };